module.exports = __webpack_public_path__ + "img/tintuc19.5bf1ff45.png";